export default __webpack_public_path__ + "static/media/Third.95c78ece.png";